import React from "react";

import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import Backdrop from "@material-ui/core/Backdrop";

import { ALMOST_WHITE } from "constants/colors";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      position: "relative",
      top: "50%",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      "& > * + *": {
        marginLeft: theme.spacing(2),
        color: ALMOST_WHITE,
      },
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: "#fff",
    },
  })
);

const Spinner = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Backdrop className={classes.backdrop} open={true}>
        <CircularProgress style={{ color: ALMOST_WHITE }} size={30} />
      </Backdrop>
    </div>
  );
};

export default Spinner;
